import * as React from 'react';
const Home = ({ fillPath, ...restProps }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...restProps}>
    <mask
      id="a"
      width={28}
      height={28}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h28v28H0z" />
    </mask>

    <path
      fill={fillPath || '#003594'}
      d="M7 22.167h3.904v-6.933h6.192v6.933H21v-10.5l-7-5.273-7 5.273v10.5Zm-1.75 1.75V10.792L14 4.207l8.75 6.585v13.125h-7.404v-6.933h-2.692v6.933H5.25Z"
    />
  </svg>
);
export default Home;
